module.exports = "/assets/data/ba227ba4f9cd9ae34440d18bbe08cfa1-GU51.data.json";